export const navbarEnLocale = {
  'navbar.sell': 'Sell your tickets',
  'navbar.login': 'LOGIN',
  'navbar.all': 'ALL COUNTRIES',
  'navbar.mytickets': 'MY TICKETS',
  'navbar.help': 'HELP',
  'navbar.country': 'Countries',
  'navbar.language': 'Language',
  'navbar.US': 'United States',
  'navbar.SV': 'El Salvador',
  'navbar.GT': 'Guatemala',
  'navbar.HN': 'Honduras',
  'navbar.CR': 'Costa Rica',
  'navbar.PA': 'Panama',
  'navbar.selected': '(Selected)',
  'navbar.menu': 'Menu',

  'navbar.updatePassword': 'Update Password',
} as const;

export const navbarEsLocale = {
  'navbar.sell': 'Vende tus tickets',
  'navbar.login': 'INGRESAR',
  'navbar.all': 'TODOS LOS PAÍSES',
  'navbar.mytickets': 'MIS TICKETS',
  'navbar.help': 'AYUDA',
  'navbar.country': 'País',
  'navbar.language': 'Idioma',
  'navbar.US': 'Estados Unidos',
  'navbar.SV': 'El Salvador',
  'navbar.GT': 'Guatemala',
  'navbar.HN': 'Honduras',
  'navbar.CR': 'Costa Rica',
  'navbar.PA': 'Panamá',
  'navbar.selected': '(Seleccionado)',
  'navbar.menu': 'Menú',
  'navbar.updatePassword': 'Actualizar Contraseña',
} as const;
